import { translationLabel } from '../lib/bible'

/**
 * A passage set the way a Bible sets it — verse numbers raised and quiet,
 * running on rather than stacked, so it reads as prose not as a list.
 */
export default function Passage({ verses, text, reference, translation, style }) {
  const list = Array.isArray(verses) && verses.length ? verses : null

  return (
    <div className="passage" style={style}>
      <p className="passagetext">
        {list
          ? list.map((v) => (
              <span key={v.verse}>
                <sup className="vnum">{v.verse}</sup>{v.text}{' '}
              </span>
            ))
          : text}
      </p>
      {(reference || translation) && (
        <div className="small" style={{ marginTop: 10 }}>
          {reference}
          {translation && <> · {translationLabel(translation)} <span style={{ opacity: .7 }}>
            ({translationLabel(translation, 'full')})</span></>}
        </div>
      )}
    </div>
  )
}
